"use client";

import { c as _c } from "react/compiler-runtime";
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { useState } from "react";
import LoginComponent from "@/components/templates/login";
export default function LoginPage() {
  const $ = _c(6);
  const [loading, setLoading] = useState(false);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get("error");
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const queryErrorMessage = t0;
  const [errorText, setErrorText] = useState(queryErrorMessage ?? undefined);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      setLoading(true);
      ;
      try {
        await signIn("whmcs");
      } catch (t2) {
        const error = t2;
        const errorMessage = error instanceof Error ? error.message : "Unknown error";
        setErrorText(errorMessage);
        setLoading(false);
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleLogin = t1;
  let t2;
  if ($[3] !== errorText || $[4] !== loading) {
    t2 = <LoginComponent errorText={errorText} loading={loading} handleLogin={handleLogin} />;
    $[3] = errorText;
    $[4] = loading;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}